<ng-template #idleWaring>
	<div class="p-4">
		<div class="fw-bold text-center fs-5 mb-4">
			Looks like you have stopped exploring. You will be logged out momentarily, or choose to continue your session
		</div>
		<table class="w-100 w-fixed">
			<colgroup><col style="width:10%" /><col/><col style="width:10%" /></colgroup>
			<tr>
				<td></td>
				<td>
					<div class="progress" style="height: 20px; background-color:silver; text-align:center;">
						<div class="progress-bar bg-info" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="percent" [style]="{width: percent + '%'}">{{warningProgress}}/{{warningDuration}} seconds</div>
					</div>
					<div class="row" style="margin:20px 0px 20px 0px; text-align:center;">
						<div class="col-6">
							<button (click)="logout();" class="btn btn-outline-primary" style="width:110px;">Logout</button>
						</div>
						<div class="col-6">
							<button (click)="stayActive();" class="btn btn-primary" style="width:110px;">Stay Active</button>
						</div>
					</div>
				</td>
				<td></td>
			</tr>
		</table>
	</div>
</ng-template>
